import { render } from "./SelectSpokenLanguages.vue?vue&type=template&id=a6298190"
import script from "./SelectSpokenLanguages.vue?vue&type=script&lang=js"
export * from "./SelectSpokenLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__